module.exports = __webpack_public_path__ + "static/media/chuyinshan_web.28fc5050.webp";